import { Reducer } from "redux";

import { ReferralServiceStatusActionDispatchTypes } from "../constants/Master";
import { ReferralServiceStatusResponse } from "../models/Api/Master";
import { ReferralServiceStatusDispatchTypes } from "../models/DispatchTypes/Master";

export const initialState: ReferralServiceStatusResponse = {
  loading: false,
  response: [],
};

const ReferralServiceReducer: Reducer<
  ReferralServiceStatusResponse,
  ReferralServiceStatusDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case ReferralServiceStatusActionDispatchTypes.REFERRAL_SERVICE_STATUS_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case ReferralServiceStatusActionDispatchTypes.REFERRAL_SERVICE_STATUS_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case ReferralServiceStatusActionDispatchTypes.REFERRAL_SERVICE_STATUS_RESET: {
      return initialState;
    }
    case ReferralServiceStatusActionDispatchTypes.REFERRAL_SERVICE_STATUS_ERROR: {
      return initialState;
    }
  }
  return state;
};

export default ReferralServiceReducer;
